import React, { FC } from 'react';
import styled from 'styled-components/macro';

import { URLS } from 'config';
import { Trans } from '@lingui/macro';

import Text from 'components/Text';

import { StyledLink } from 'components/StyledCommon';

const Separator = styled.span<{
    linkTheme: 'light' | 'dark';
}>`
    color: ${({ theme, linkTheme }) =>
        linkTheme === 'light' ? theme.colors.labels : theme.colors.darkGrey};
    display: inline-block;
    padding: 0 4px;
    &:after {
        content: '|';
    }
`;

const LegalLinks: FC<
    {
        theme: 'light' | 'dark';
    } & React.HTMLAttributes<HTMLDivElement>
> = ({ theme, ...rest }) => {
    return (
        <Text align="center" spaceTop="large" spaceBottom="large" {...rest}>
            <StyledLink
                $color={theme === 'light' ? 'labels' : 'darkGrey'}
                href={URLS.terms}
            >
                <Trans>Terms of Service</Trans>
            </StyledLink>
            <Separator linkTheme={theme} />
            <StyledLink
                $color={theme === 'light' ? 'labels' : 'darkGrey'}
                href={URLS.privacyNotice}
            >
                <Trans>Privacy Policy</Trans>
            </StyledLink>
            <Separator linkTheme={theme} />
            <StyledLink
                $color={theme === 'light' ? 'labels' : 'darkGrey'}
                href={URLS.support}
            >
                <Trans>Support</Trans>
            </StyledLink>
        </Text>
    );
};

export default LegalLinks;
